// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";

const mapQuoteOption = (options: Toolkit.GoogleAnalytics.Options | undefined): Toolkit.GoogleAnalytics.Event => {
    if (!options?.quote) {
        return {};
    }

    const { id, quoteLineCollection, notes, orderGrandTotal, type } = options.quote;

    return {
        has_notes: Boolean(notes),
        item_list_id: id,
        items: !options?.skipOptionItems ? ga.map.items(quoteLineCollection) : undefined,
        type: type.toLowerCase(),
        value: orderGrandTotal,
    };
};

export default mapQuoteOption;
